import React from "react";
import { motion } from "framer-motion";
import { MapPin } from "lucide-react";

const AREAS = [
  { name: "London", sub: "All postcodes" },
  { name: "Central London", sub: "Zones 1–2" },
  { name: "Canary Wharf", sub: "E14 & Isle of Dogs" },
  { name: "East London", sub: "Including Dagenham (base)" },
  { name: "Greater London", sub: "Zones 3–6" },
  { name: "M25 Corridor", sub: "Happy to travel" },
];

export default function AreasCovered() {
  return (
    <section
      id="areas"
      data-testid="areas-covered-section"
      className="bg-white text-[#2B2420] py-20 md:py-28"
    >
      <div className="px-6 md:px-10 lg:px-16 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.3em] text-[#B8732C] mb-5">
            <span className="brand-gold-divider" /> Areas we cover
          </div>
          <h2
            className="font-black tracking-tighter leading-[0.95] text-4xl md:text-5xl lg:text-6xl"
            style={{ fontFamily: "Cabinet Grotesk" }}
          >
            London-wide. <br /> Based in Dagenham.
          </h2>
          <p className="mt-5 text-[#4D4037] text-base md:text-lg leading-relaxed max-w-md">
            From Central London and Canary Wharf to Greater London and the M25
            corridor — our crews work across every zone.
          </p>
        </div>

        <div className="lg:col-span-7 grid grid-cols-2 md:grid-cols-3 border-t border-l border-[#E5DDD0]">
          {AREAS.map((a, i) => (
            <motion.div
              key={a.name}
              data-testid={`area-${a.name.toLowerCase().replace(/\s/g, "-")}`}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.45, delay: i * 0.05 }}
              className="border-r border-b border-[#E5DDD0] p-5 md:p-7 bg-white hover:bg-[#F5EFE5] transition-colors flex flex-col justify-between min-h-[130px]"
            >
              <MapPin className="w-5 h-5 text-[#C9A24C]" />
              <div className="mt-6">
                <div
                  className="font-black text-lg md:text-xl leading-tight"
                  style={{ fontFamily: "Cabinet Grotesk" }}
                >
                  {a.name}
                </div>
                <div className="text-xs md:text-sm text-[#8A7F74] mt-1">{a.sub}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
